/**
 * @desc 通过sku列表获取sku信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.SkuListResponseDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/sku/byUniqueSkuList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
